

































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import Auth from '../comps/Auth'
import moment from 'moment'
import showdown from 'showdown'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { user } from '../mapper'
import rounder from '../rounder.js'
import MDE from 'vue-simplemde'
import axios from 'axios'
import SoldChart from '../comps/SoldChart'
util = require('util')

export default
    data: -> # the fields need to exist for reactivity to work with Object.assign
        user: user
        language: 'en'
        event:
            name:
                en: ''
            members_only: false
            hidden: false # private: false
            unified: false
            # requires_address: false
            aliases: ''
            aliasmap: {}
            description:
                en: ''
            date: ''
            address: {}
            seats:
                taken: 0
                max: 0
            cheapest: 0
            currency: 'HUF'
            deleted: false # active: true
            stream:
                url: ''
                password: ''
        passes: []
        coupons: []
        stats: []
        isLoading: false
        error: ''
        error_in_ticket: ''
        open: []
    mounted: ->
        this.fetch()
    beforeRouteUpdate: (to, from, next) ->
        this.fetch(to.params.id)
        next()
    computed:
        mdconfig: ->
            placeholder: this.$t('description')
            hideIcons: ['image', 'fullscreen', 'side-by-side', 'guide']
            spellChecker: false
            status: false
        languages: ->
            array = []
            for code, string of this.$languages()
                map = {}
                map[code] = string
                array.push map
            return array
        seats: -> this.event.seats.max - this.event.seats.taken
        map: ->
            city = this.event?.address?.city
            zip = this.event?.address?.zip
            line = this.event?.address?.line
            unless city? && zip? && line? then return ''
            url = 'https://maps.googleapis.com/maps/api/staticmap'
            url += '?key=' + 'AIzaSyCc_1gKBKTssXQZ6NIXMLXS2dlwGcaIPOw'
            url += '&markers=' + city + ',' + zip + ',' + line
            url += '&size=' + '800x232'
            return url
    methods:
        moment: moment
        rounder: rounder
        fetch: (to) ->
            id = to ? this.$route.params.id
            if id == 'new' then return null
            firebase.firestore().collection('events').doc(id).onSnapshot (doc) =>
                e = doc.data()
                e.id = doc.id
                date = e.date.toDate()
                e.date = moment(date).format('YYYY.MM.DD')
                e.time = moment(date).format('HH:mm')
                Object.assign this.event, e

                # Passes
                if this.isLoading then return undefined
                firebase.firestore().collection('events').doc(doc.id).collection('passes').onSnapshot (snap) =>
                    px = snap.docs.map (doc) -> 
                        p = doc.data()
                        p.id = doc.id
                        p.availability.date = moment(p.availability.date.toDate()).format('YYYY.MM.DD HH:mm')
                        return p
                    this.passes = px

                    # Coupons
                    firebase.firestore().collection('events').doc(doc.id).collection('coupons').onSnapshot (snap) =>
                        cx = snap.docs.map (doc) -> 
                            c = doc.data()
                            c.id = doc.id
                            return c
                        this.coupons = cx

                        # Tickets
                        firebase.firestore().collectionGroup('tickets').where('event_id', '==', id).where('paid', '==', true).onSnapshot (snap) =>
                            tickets = []
                            snap.forEach (doc) -> ticket = doc.data(); ticket.id = doc.id; tickets.push ticket
                            this.tickets = tickets
                            console.log 'TS', tickets

                            # Stats
                            stats = []
                            sumsold = this.passes.reduce ((r, c) -> r+c.availability.taken), 0
                            stats.push
                                title: 'sold'
                                dataset:
                                    labels: [this.$t('sold'), this.$t('unsold')]
                                    data: [sumsold, this.event.seats.max]
                            sumread = this.tickets.reduce ((r, c) -> if c.read then r+1 else r), 0
                            stats.push
                                title: 'showedup'
                                dataset:
                                    labels: [this.$t('showedup'), this.$t('didnt')]
                                    data: [sumread, sumsold]
                            countries = tickets.reduce ((r, c) ->
                                val = r[c.user.address.country] ? 0
                                r[c.user.address.country] = val + 1
                                return r), {}
                            stats.push
                                title: 'countries'
                                dataset:
                                    labels: Object.keys(countries)
                                    data: Object.values(countries)
                            this.stats = stats
                
        computeStatePercent: (stat) ->
                max = stat.dataset.data[1]
                max = 1 unless max > 0
                rounder((stat.dataset.data[0] / max * 100), 2)
        computeCountryClass: (n) -> if n%2 == 0 then 'end' else ''
        computeBreak: (n) -> if n%2 == 0 then '<br/>' else ''
        isNumber: (i) -> typeof i is 'number' && (i%1) is 0
        toNumber: (i, otherwise = 0) -> if this.isNumber(i) then i else otherwise
        deviseAlias: ->
            if this.event.aliasmap[this.language] == undefined
                alias = this.event.name[this.language].replace /[^a-zA-Z0-9]/g, ''
                alias = alias.toLowerCase()
                Vue.set this.event.aliasmap, this.language, alias
        countryFor: (code) ->
            map = this.$countries().filter((c) => Object.keys(c)[0] == code)[0]
            Object.values(map)[0]
        addPass: ->
            this.error_in_ticket = ''
            name_element = document.getElementById('newname')
            price_element = document.getElementById('newprice')
            max_element = document.getElementById('newmax')
            date_element = document.getElementById('newavailability')
            guests_element = document.getElementById('newguests')

            name = name_element.value
            price = price_element.value
            guests = guests_element.value
            unless this.event.date != '' && this.event.time != '' then this.error_in_ticket = this.$t('set_date_first'); return undefined
            unless this.event.seats.max != 0 then this.error_in_ticket = this.$t('set_seats_first'); return undefined
            unless name != '' && price != '' then this.error_in_ticket = this.$t('no_pass_name_or_price'); return undefined
            max = max_element.value
            date = date_element.value
            pass =
                name: {}
                price:
                    currency: this.event.currency
                    amount: Number price
                availability:
                    max: if max != '' then Number max else Number this.event.seats.max
                    taken: 0
                    date:  if date != '' then date else this.event.date+' '+this.event.time
                guests: guests
                exists: false
            pass.name[this.language] = name
            this.passes.push pass
            
            name_element.value = ''
            price_element.value = ''
            max_element.value = ''
            date_element.value = ''
            guests_element.value = ''
            this.open = this.open.filter (c) => c != 'addpass'

        removePass: (id) ->
            this.error_in_ticket = ''
            pass = this.passes.filter((p) -> p.id == id)[0]
            unless pass? then console.log 'Cannot delete unknown pass'; return undefined
            if pass.exists == false
                this.passes.splice this.passes.indexOf(pass), 1
            else
                if confirm(this.$t('really_delete_pass'))

                    batch = firebase.firestore().batch()

                    # Remove pass
                    try
                        doc = await firebase.firestore().collection('events').doc(this.event.id).collection('passes').doc(id).get()
                        p = doc.data()
                        unless p.availability.taken == 0 then this.error_in_ticket = this.$t('cannot_delete_bought_pass'); return undefined
                        ref = firebase.firestore().collection('events').doc(this.event.id).collection('passes').doc(id)
                        batch.delete ref
                    catch e then this.error_in_ticket = e.message

                    # Remove coupons
                    for coupon in this.coupons
                        if coupon.pass_id == id
                            ref = firebase.firestore().collection('events').doc(this.event.id).collection('coupons').doc(coupon.id)
                            batch.delete ref
                    
                    try await batch?.commit()
                    catch e then console.log e; this.error_in_ticket = e.message

        addPrice: (id) ->
            country_element = document.getElementById 'addprice_country_'+id
            price_element = document.getElementById 'addprice_price_'+id
            
            country = country_element?.value
            price = price_element?.value
            
            this.passes.forEach (pass) ->
                if pass.id == id
                    pass.price.modifiers = {} if pass.price.modifiers is undefined
                    pass.price.modifiers[country] = price
            
            this.open = this.open.filter (c) => c != 'addprice_'+id

        removePrice: (id, code) ->
            this.passes.forEach (pass) ->
                if pass.id == id
                    Vue.delete pass['price']['modifiers'], code
        
        addCoupon: (pass) ->
            code_element = document.getElementById 'addcoupon_addcode_'+pass
            discount_element = document.getElementById 'addcoupon_adddiscount_'+pass
            applicable_element = document.getElementById 'addcoupon_addapplicablefor_'+pass
            uses_element = document.getElementById 'addcoupon_adduses_'+pass

            code = code_element.value
            discount = discount_element.value
            applicable = applicable_element.value
            uses = uses_element.value

            coupon =
                id: Math.round (new Date()).getTime()
                pass_id: pass
                code: code
                discount: discount
                applicable_for: Number applicable
                max_uses: Number uses
                exists: false

            this.coupons.push coupon
            this.open = this.open.filter (c) => c != 'addcoupon_'+pass

        removeCoupon: (id) ->
            coupon = this.coupons.filter((c) -> c.id == id)[0]
            unless coupon then return undefined

            if confirm(this.$t('really_delete_coupon'))
                if coupon.exists == undefined
                    try await firebase.firestore().collection('events').doc(this.event.id).collection('coupons').doc(id).delete()
                    catch e then this.error_in_ticket = e.message
                else
                    this.coupons = this.coupons.filter (c) -> c.id != id
        
        copy: (code, passId) ->
            temp = document.createElement("input")
            temp.style = "position: absolute; left: -1000px; top: -1000px"
            temp.value = window.location.host + '/events/' + this.event.aliasmap[this.language] + '#' + code
            document.body.appendChild(temp)
            temp.select()
            document.execCommand("copy")
            document.body.removeChild(temp)

            copy = document.getElementById('copy_' + passId + '_' + code)
            copy.innerHTML = 'Copied ✓'

        validate: ->
            for name in Object.values(this.event.name)
                unless name != '' then this.error = this.$t('missing_name'); return false

            for alias in Object.values(this.event.aliasmap)
                correct = alias.match "^[a-z0-9]+$"
                unless correct && alias != '' then this.error = this.$t('invalid_alias'); return false

            for desc in Object.values(this.event.description)
                unless desc != '' then this.error = this.$t('missing_desc'); return false

            unless this.event.date != '' then this.error = this.$t('missing_date'); return false
            unless this.event.time != '' then this.error = this.$t('missing_time'); return false
            if this.event.stream.url != '' || this.event.stream.password != ''
                if this.event.stream.url == '' || this.event.stream.password == ''
                    this.error = this.$t('incomplete_stream_details'); return false
            else
                unless this.event.address.city? && this.event.address.zip? && this.event.address.line? && \
                this.event.address.city != '' && this.event.address.zip != '' && this.event.address.line != ''
                    this.error = this.$t('incomplete_address'); return false
            unless this.event.seats.max != 0 then this.error = this.$t('missing_seats'); return false
            unless this.event.seats.max >= this.event.seats.taken then this.error = this.$t('too_few_seats'); return false

            for pass in this.passes
                if pass.availability.taken?
                    unless pass.availability.max >= pass.availability.taken
                        this.error_in_ticket = this.$t('too_few_seats_for_ticket')

            return true
        save: ->
            
            # Validate
            unless this.validate() then return undefined
            this.isLoading = true
            this.error = ''


            # Coordinates
            coordinates = null
            if this.event.address.city?
                url = 'https://maps.googleapis.com/maps/api/geocode/json'
                url += '?key=' + 'AIzaSyCc_1gKBKTssXQZ6NIXMLXS2dlwGcaIPOw'
                url += '&address=' + this.event.address.line + '+' + this.event.address.zip + '+' + this.event.address.city
                
                try
                    response = await axios.get(url)
                    results = response.data.results
                    geocode = results[0]
                    location = geocode.geometry.location
                    coordinates =
                        latitude: location.lat
                        longitude: location.lng
                catch e then console.log 'Geocoding error', e; this.error = e
                unless coordinates.latitude? && coordinates.longitude? then this.error = this.$t('unable_get_coordinates'); return undefined


            # Cheapest
            valid_passes = this.passes.filter (p) ->
                passDate = new Date p.availability.date.split('.').join('-').split(' ').join('T')
                moment(passDate).isAfter(moment(), 'day') && p.availability.max - p.availability.taken > 0
            cheapest = valid_passes.reduce ((r, c) ->
                ca = c.price.amount
                return Math.min(r, ca)), 1000000

            # DTO
            event = JSON.parse(JSON.stringify(this.event))
            event.aliases = Object.values(event.aliasmap).map (a) -> a
            event.address.coordinates = coordinates
            event.seats.max = Number event.seats.max
            m = moment(event.date.split('.').join('-') + 'T' + event.time + ':00.000')
            date = m.toDate()
            event.date = firebase.firestore.Timestamp.fromDate(date)
            event.cheapest = cheapest
            delete event.id
            delete event.time

            ref = firebase.firestore().collection('events')
            if this.event.id then ref = ref.doc(this.event.id)
            else ref = ref.doc()
            
            try await ref.set(event)
            catch e then console.log 'Unable to save event', e; this.error = e.message
            finally this.isLoading = false


            # Passes & Coupons
            batch = undefined
            this.isLoading = true

            # passes
            for pass in this.passes
                batch = firebase.firestore().batch() unless batch?
                pass_date = undefined
                if pass.availability.date?
                    m = moment(pass.availability.date.split('.').join('-').split(' ').join('T'))
                    pass_date = m.toDate()
                else pass_date = date

                p =
                    name: pass.name
                    price: pass.price
                    availability:
                        max: Number pass.availability.max ? Number this.event.seats.max
                        date: firebase.firestore.Timestamp.fromDate(pass_date)
                    guests: Number pass.guests
                p.availability.taken = 0 if pass.exists == false

                doc = firebase.firestore().collection('events').doc(ref.id).collection('passes')  
                doc = if pass.id? then doc = doc.doc(pass.id) else doc = doc.doc()
                batch.set doc, p, merge: true

            # # coupons
            # for coupon in this.coupons

            #     # THE PASS NEEDS TO EXIST FIRST, SO THIS IS NOT WORKING
            #     c =
            #         pass_id: coupon.pass_id
            #         code: coupon.code
            #         discount: coupon.discount
            #         applicable_for: coupon.applicable_for
            #         max_uses: coupon.max_uses

            #     # Add coupon to batch
            #     batch = firebase.firestore().batch() unless batch?
            #     doc = firebase.firestore().collection('events').doc(ref.id).collection('coupons')  
            #     if coupon.exists == undefined
            #         doc = doc.doc(coupon.id)
            #     else
            #         doc = doc.doc()
            #     batch.set doc, c, merge: true
            
            try await batch?.commit()
            catch e then console.log 'Unable to save passes', e; this.error = e.message
            finally this.isLoading = false

            ## Coupons
            c_batch = undefined
            this.isLoading = true
            for coupon in this.coupons

                c =
                    pass_id: coupon.pass_id
                    code: coupon.code
                    discount: coupon.discount
                    applicable_for: coupon.applicable_for
                    max_uses: coupon.max_uses

                # Add coupon to batch
                c_batch = firebase.firestore().batch() unless c_batch?
                doc = firebase.firestore().collection('events').doc(ref.id).collection('coupons')  
                if coupon.exists == undefined
                    doc = doc.doc(coupon.id)
                else
                    doc = doc.doc()
                c_batch.set doc, c, merge: true

            try await c_batch?.commit()
            catch e then console.log 'Unable to save coupons', e; this.error = e.message
            finally this.isLoading = false

            unless this.event.id?
                this.$router.push({name: 'edit', params: {'id': ref.id}})

        attendees: ->
            this.$router.push name: 'attendees', params: {event: this.event.id}, query: {name: this.$tt(this.event.name)}
        ask_trash: -> this.trash() unless not confirm(this.$t('really_delete'))
        trash: ->
            this.isLoading = true
            try await firebase.firestore().collection('events').doc(this.event.id).update('deleted': true)
            catch e then console.log 'Unable to delete event', e; this.error = e.message
            finally this.isLoading = false
            this.$router.push {name: 'events'}
        ask_untrash: -> this.untrash() unless not confirm(this.$t('really_take_out'))
        untrash: ->
            this.isLoading = true
            try await firebase.firestore().collection('events').doc(this.event.id).update('deleted': false)
            catch e then console.log 'Unable to untrash event', e; this.error = e.message
            finally this.isLoading = false

    components: { MDE, SoldChart }
